<div class="p-16" fxLayout="column" [formGroup]="consultationCallBackRequestForm" fxLayoutAlign="space-between center">
    <div fxLayout="row">
        <div fxLayout="column" class="modal">
            <div fxLayout="column" class="phone-container">
                <div class="mt-8">
                    <div fxFlex="100" class="phone-outline">
                        <label class="phone-outline-label">
                            {{ "APP_CREATE_CASE.PHONE" | translate }}
                        </label>
                        <div fxFlex="100" class="phone-outline-box">
                            <div fxLayout="column" fxFlex="100">
                                <div fxLayout="row">
                                    <ngx-mat-intl-tel-input
                                        class="input-text-position-fixed"
                                        formControlName="Phone"
                                        [enablePlaceholder]="true"
                                        [enableSearch]="true"
                                        [preferredCountries]="['ch']"
                                        inputPlaceholder="{{ 'APP_CREATE_CASE.PHONE' | translate }}"
                                    >
                                    </ngx-mat-intl-tel-input>
                                    <a
                                        class="mr-8 mt-8 col-green"
                                        href="tel:{{ consultationCallBackRequestForm.value.Phone }}"
                                    >
                                        <mat-icon style="background: none" matSuffix>call</mat-icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="error-container">
                    <div
                        class="error-msg error-msg-color"
                        *ngIf="
                            consultationCallBackRequestForm.controls['Phone']?.errors?.validatePhoneNumber &&
                            !consultationCallBackRequestForm.controls['Phone']?.errors?.landlineNumber
                        "
                    >
                        <span>{{ "APP_CREATE_CASE.PHONE_NUMBER_INVALID" | translate }}</span>
                    </div>
                    <div
                        class="error-msg error-msg-color"
                        *ngIf="consultationCallBackRequestForm.controls['Phone']?.errors?.landlineNumber"
                    >
                        <span>{{ "APP_CREATE_CASE.LANDLINE_SMS_NOT_SEND" | translate }}</span>
                    </div>
                </div>
            </div>

            <div fxLayout="column" class="mt-24">
                <div class="form-field-width">
                    <p-floatlabel variant="on" class="form-field-width">
                        <p-iconfield>
                            <input
                                class="form-placeholder"
                                pInputText
                                type="email"
                                formControlName="Email"
                                maxlength="2500"
                            />
                            <p-inputicon>
                                <a
                                    matSuffix
                                    fxLayout="row"
                                    class="mr-8"
                                    fxLayoutAlign="start center"
                                    style="text-decoration: none"
                                    href="{{ 'mailto:' + consultationCallBackRequestForm.value.Email }}"
                                >
                                    <i class="col-green pi pi-envelope" style="background: none"></i>
                                </a>
                            </p-inputicon>
                        </p-iconfield>

                        <label>{{ "APP_CASES.EMAIL" | translate }}</label>
                    </p-floatlabel>
                    <div class="h-4">
                        <p-message
                            *ngIf="consultationCallBackRequestForm.get('Email').hasError('email')"
                            severity="warn"
                            text="{{ 'APP_CASES.INVALID_EMAIL' | translate }}"
                        >
                        </p-message>
                    </div>
                </div>
            </div>

            <div fxLayout="column" class="mt-24">
                <p-floatlabel variant="on" class="form-field-width">
                    <label>{{ "APP_CASES.NAME" | translate }}*</label>
                    <input class="form-placeholder" pInputText type="text" formControlName="Name" />
                </p-floatlabel>
            </div>

            <div fxLayout="column" class="mt-24">
                <p-floatlabel variant="on" class="form-field-width" *ngIf="!policyHolderInfo">
                    <label>{{ "APP_CASES.OFFER_NAME" | translate }}*</label>
                    <input class="form-placeholder" pInputText type="text" formControlName="OfferNumber" />
                </p-floatlabel>

                <p-floatlabel variant="on" class="form-field-width" *ngIf="policyHolderInfo">
                    <label>{{ "APP_CASES.CASE_REPORT_NUMBER" | translate }}</label>
                    <input class="form-placeholder" pInputText type="text" formControlName="ClaimNumber" />
                </p-floatlabel>
            </div>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-16">
        <div>
            <p-button
                ariaLabelledBy="Close"
                (click)="onClose()"
                [disabled]="isLoading"
                label="{{ 'APP_CASES.CLOSE' | translate }}"
                icon="pi pi-times"
                severity="danger"
            />
        </div>
        <div class="ml-16">
            <p-button
                ariaLabelledBy="Save"
                [disabled]="!isAllowedToRequest"
                label="{{ 'APP_CASES.SEND' | translate }}"
                (click)="onSendRequest()"
                *ngIf="!isLoading"
            />
            <mat-progress-spinner *ngIf="isLoading" [diameter]="20" mode="indeterminate"></mat-progress-spinner>
        </div>
    </div>
</div>
